const Styles = {
  labelTextBox: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  labelTextCheckBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
  },
  submitBtn: {
    width: "100%",
    display: "flex",

    alignItems: "flex-end",
  },

  basicDatePicker: { width: "100%", fontWeight: "600", marginTop: "10px" },
  addEmailStash: {
    width: "100%",
    fontWeight: "600",
  },
};

export default Styles;
